/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 * @return {?}
 */
export function supportsState() {
    return !!window.history.pushState;
}
//# sourceMappingURL=history.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/platform-browser/src/browser/location/history.js
// module id = 862
// module chunks = 8